@if (initialized && dto) {
    <div class="mt-3">

        <!--*********************************      Allgemein      *********************************-->

        @if (activeNavigationItem?.action == 'ct.CampaignTypeConfig') {
            <div class="grid">
                <div class="col-12">
                    @if (campaignTypeConfigWidget) {
                        <mvs-widget [widgetData]="campaignTypeConfigWidget"></mvs-widget>
                    }
                </div>
            </div>
        }

        <!--*************************      Mitgliedstatus-Typen      **************************-->

        @if (activeNavigationItem?.action == 'ct.CampaignMemberStatusType') {
            <div class="grid">
                <div class="col-12">
                    @if (campaignMemberStatusTypeWidget) {
                        <mvs-widget
                            [widgetData]="campaignMemberStatusTypeWidget"
                            (onObjectSelect)="handleObjectView($event, 'e.id', 'ct.CampaignMemberStatusType')"
                        ></mvs-widget>
                    }
                </div>

                <div class="col-8">
                    @if (objectViewWidget && !isCreateMode) {
                        <mvs-widget [widgetData]="objectViewWidget"></mvs-widget>
                    }
                </div>
            </div>
        }

        <!--***************************      Kampagnenvorlagen      ****************************-->

        @if (activeNavigationItem?.action == 'ct.CampaignTemplate') {
            <div class="grid">
                <div class="col-12">
                    @if (campaignTemplateWidget) {
                        <mvs-widget
                            [widgetData]="campaignTemplateWidget"
                            (onObjectSelect)="handleObjectView($event, 'e.id', 'ct.CampaignTemplate')"
                        ></mvs-widget>
                    }
                </div>

                <div class="col-8">
                    @if (objectViewWidget && !isCreateMode) {
                        <mvs-widget [widgetData]="objectViewWidget"></mvs-widget>
                    }
                </div>
            </div>
        }

    </div>
}
